import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" subtitle="Legal" testId="privacy-page">
      <p>At THE FABRICS, your privacy is our priority. This policy explains how we collect, use, and protect your personal information.</p>

      <h2>Information We Collect</h2>
      <ul>
        <li>Contact details: name, email address, phone number, shipping address.</li>
        <li>Order information: items purchased, size, payment method, order value.</li>
        <li>Account information: login credentials for members who register with us.</li>
        <li>Device &amp; usage data: browser type, IP address, pages visited (via cookies).</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To process and deliver your orders.</li>
        <li>To communicate with you about your order, shipping, and support requests.</li>
        <li>To improve our website, products, and customer experience.</li>
        <li>To send marketing communications only when you opt in.</li>
      </ul>

      <h2>Sharing &amp; Third Parties</h2>
      <p>We share information strictly with trusted partners who help us operate our business — including payment gateways (e.g. Razorpay), shipping carriers, and analytics providers. We do not sell your personal data to anyone.</p>

      <h2>Data Security</h2>
      <p>All transactions are encrypted using industry-standard SSL. Payment information is handled by PCI-DSS compliant gateways and is never stored on our servers.</p>

      <h2>Your Rights</h2>
      <p>You may request access, correction, or deletion of your personal data at any time by writing to <a href="mailto:thefabrics37@gmail.com">thefabrics37@gmail.com</a>.</p>

      <h2>Contact</h2>
      <p>THE FABRICS · Dharuhera, Haryana, India · <a href="mailto:thefabrics37@gmail.com">thefabrics37@gmail.com</a> · +91 97299 27206.</p>

      <p className="opacity-60 text-sm mt-8">Last updated: February 2026</p>
    </LegalPage>
  );
}
